import { motion, AnimationDefinition } from "motion/react";

type Props = { direction: "left" | "right"; children: any; onTransitionComplete: Cb };

const movements = {
  left: "-25%",
  right: "25%"
};

export default function SceneAnimation({ direction, children, onTransitionComplete }: Props) {
  const movement = movements[direction];

  const variants = {
    initial: { x: movement, opacity: 0 },
    animate: { x: 0, opacity: 1 },
    exit: { x: movement, opacity: 0 }
  };

  const handleTransition = (definition: AnimationDefinition) => {
    if (definition === "animate") onTransitionComplete();
  };

  return (
    <motion.div
      variants={variants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.2 }}
      style={{ height: "calc(100% - 76px)", display: "flex", flexDirection: "column" }}
      onAnimationComplete={handleTransition}
    >
      {children}
    </motion.div>
  );
}
